// extracted by mini-css-extract-plugin
module.exports = {"page-spinner":"spinner__page-spinner___2P68m","pageSpinner":"spinner__page-spinner___2P68m","spin":"spinner__spin___13hNv","small":"spinner__small___1HsKn"};